import { ColumnResponseModel } from "./column-response.model";

export class FilterGlobalResponseModel {
  filtersGlobal: ColumnResponseModel[] = [];
  columns: ColumnResponseModel[] = [];
}